module.exports = __webpack_public_path__ + "static/media/noMaterial.60b5eb95.svg";